import { Button, Card, Checkbox, IconButton, LinearProgress, Tooltip, Typography } from '@mui/material';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import React, { Component } from 'react'
import { MdDragIndicator, MdInfo } from 'react-icons/md';
import { Link } from 'react-router-dom';
import { AppContext } from '../../../../AppContext';
import ApiRequestService from '../../../../components/ApiRequestService';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import { FaCirclePlus } from 'react-icons/fa6';
import SFNoData from '../../../SFComponents/SFNoData';
import SFPublicSkillsLibrary from '../../../SFComponents/SFPublicSkillsLibrary';
import { NotificationManager } from 'react-notifications';
import {
    MaterialReactTable,
} from 'material-react-table';
import { getDateFormat } from '../../../../common/functions';
import MomentTz from 'moment-timezone'
import { RxCaretRight } from "react-icons/rx";
import { FaCheck } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import { IoIosArrowUp } from "react-icons/io";
import moment from 'moment-timezone';

class SkillsWidget extends Component {

    static contextType = AppContext;

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            skills: [], // skills is nothing but assignments
            timeZone: null,
        }
    }

    componentDidMount() {
        this.getSkillProgress()
    }

    getBGStatusColor = (state) => {
        let colorClass = '';
        switch (state) {
            /*  case "Start":
                 colorClass = 'bg-scarlet'
                 break; */
            case "In Progress", "Start":
                colorClass = 'bg-white'
                break;
            case "Completed":
                colorClass = 'bg-success'
                break;
            case "Past":
                colorClass = 'bg-secondary'
                break;
            case "Up Next":
                colorClass = 'bg-blue'
                break;

            default:
                break;
        }

        return colorClass;
    }

    handleTakeQuizURL = (assignment) => {

        // TODO: Probably will change the takequiz name
        let url = `/takequiz?quiz_id=${assignment.quizID || assignment.quiz_id}&course_id=${assignment.courseID || assignment.course_id}&section_id=${assignment.sectionID || assignment.section_id}&quiz_name=${assignment.quizName || assignment.quiz_name}&quiz_type=${assignment.quizType || assignment.quiz_type}&course_name=${assignment.courseName || assignment.course_name}`

        this.props.handleRoute(url)
    }


    getSkillProgress() {
        this.setState({
            loading: true,
        })
        ApiRequestService({
            method: "GET",
            url: "/getSkillProgress",
        }).then(res => {
            if (res && res.data && res.data.status === 1) {
                NotificationManager.error(res.data.message, "ERROR", 3000);
                return
            }
            let skillsArr = [];
            if (res && res.data && res.data.data) {
                skillsArr = res.data.data.data;
            } else {
                skillsArr = [];
            }
            let timeZone = res.data?.data?.time_zone
            this.setState({ timeZone: timeZone });

            let newSkillsArr = skillsArr.map((assign) => {

                let today = new Date();
                let start_date = MomentTz.tz(assign.start_date + " " + assign.start_time, 'DD/MM/YYYY hh:mm:ss', timeZone).toDate();
                let end_date = MomentTz.tz(assign.end_date + " " + assign.end_time, 'DD/MM/YYYY hh:mm:ss', timeZone).toDate();

                let state = "";
                if (assign.is_finish === 1) {
                    state = "Completed";
                } else if (today.getTime() < start_date.getTime()) { // Up next
                    state = "Up Next"
                } else if (today.getTime() > start_date.getTime() && today.getTime() < end_date.getTime()) { // Past/Closed
                    state = "Start"
                    if (assign.is_finish === 0 && assign.finalscore_start_time?.length) {
                        state = "In Progress"
                    }
                } else {
                    state = "Past"
                }
                return {
                    ...assign,
                    state: state,
                    startDateAndTime: start_date,
                    endDateAndTime: end_date,
                }
            });

            newSkillsArr = newSkillsArr.filter(skill => skill.state === "In Progress" || skill.state === "Completed");

            this.setState({ skills: newSkillsArr });
            console.debug("newSkillsArr", newSkillsArr)
            if (newSkillsArr?.length === 0) {
                this.props.onNoData();
            }
        }).finally(() => {
            this.setState({
                loading: false,
            })
        })
    }


    render() {
        const { skills, loading } = this.state;

        const columns = [
            {
                accessorKey: 'quiz_name',
                header: 'Quiz Name',
                size: 100,
            },
            {
                accessorKey: 'completion_percentage',
                header: 'Score',
                size: 80,
                accessorFn: (assignment) => {
                    if (assignment.fullScoreIfAttempted === 1) {
                        if (assignment.is_finish === 1) return "100%"
                        return "0%"
                    }

                    return Math.round(parseFloat(assignment.completion_percentage)) + "%";
                },
            },
            {
                accessorKey: 'start_time',
                header: 'Start Date',
                size: 80,
                accessorFn: (assignment) => {
                    let startDate = "";
                    if (assignment.finalscore_start_time && assignment.finalscore_start_time.length) {
                        startDate = assignment.finalscore_start_time[0];
                    }
                    if (startDate) {
                        startDate = moment(startDate, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY");
                        return getDateFormat(startDate, this.state.timeZone);
                    }
                    return "N/A"
                },
            },
            {
                accessorKey: 'completed_date',
                header: 'Completion Date',
                size: 80,
                accessorFn: (assignment) => {
                    if (assignment.completed_date) {
                        let date = moment(assignment.completed_date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY");
                        return getDateFormat(date, this.state.timeZone);
                    }
                    return "N/A"
                },
            },
            {
                accessorKey: 'state',
                header: 'Status',
                enableSorting: false,
                size: 2,

                accessorFn: (assignment) => {
                    // console.debug("assignmentassignment", assignment)

                    let isResume = false;
                    let score = assignment.scores?.find(score => score.practice_number === assignment.practice_count);
                    if (score && score.is_finish === 0) {
                        isResume = true;
                    }
                    let canPratice = assignment.is_finish && assignment.allow_practice;
                    console.debug("assignment>>??", assignment)
                    return (
                        <div className='d-flex justify-content-center align-items-center' style={{ gap: "12px" }}>
                            <div style={{
                                width: '26px',
                                height: '26px',
                                borderRadius: '13px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                cursor: (assignment.state === "Start" || assignment.state === "In Progress") ? 'pointer' : 'default'
                            }} className={this.getBGStatusColor(assignment.state)}
                            >
                                {/*  {(assignment.state === "Start") ?
                                                <RxCaretRight fontSize={28} color='white' fontWeight={'500'} />
                                                : null} */}
                                {assignment.state === "In Progress" || assignment.state === "Start" ?
                                    <div style={{
                                        border: '1px solid #bb0000',
                                        borderRadius: '50%',
                                        width: '26px',
                                        height: '26px',
                                    }} className='d-flex justify-content-center align-items-center'>
                                        <RxCaretRight fontSize={28} color='#bb0000' fontWeight={'500'} />
                                    </div>
                                    : null}
                                {(assignment.state === "Completed") ?
                                    <FaCheck fontSize={16} color='white' />
                                    : null}
                                {(assignment.state === "Past") ?
                                    <IoClose fontSize={16} color='white' />
                                    : null}
                                {(assignment.state === "Up Next") ?
                                    <IoIosArrowUp fontSize={16} color='white' />
                                    : null}
                            </div>
                        </div>
                    )
                },
            },
            {
                accessorKey: 'practice',
                header: <div>
                    <span>Extra Practice</span>
                    <Tooltip title={
                        <Typography color='#fff'>
                            You can practice assignment here (or) create your own practice set from "Performance Analytics" or "Build your own Practice Sets" cards.
                        </Typography>
                    } placement='top' arrow>
                        <span className='ml-1'><MdInfo color='#646a6e' /></span>
                    </Tooltip>
                </div>,
                size: 140,
                enableHiding: true,
                accessorFn: (assignment) => {
                    if (assignment.is_finish && assignment.quiz_type === 0) {

                        let isResume = false;
                        let score = assignment.scores?.find(score => score.practice_number === assignment.practice_count);
                        if (score && score.is_finish === 0) {
                            isResume = true;
                        }

                        return (
                            <div>
                                <Tooltip placement='top' title={`Number of times practiced: ${assignment.practice_count - 1}`}>
                                    <Button variant='contained' size='small'
                                        disabled={this.props.selectedStudentUserName}
                                        onClick={() => {
                                            this.handleTakeQuizURL(assignment)
                                        }}>
                                        {isResume ? "Resume Practice" : "Practice Again"}
                                    </Button>
                                </Tooltip>
                            </div>
                        )
                    } else {
                        return ""
                    }
                },
            },
        ];

        return (
            <Card className='h-100 w-100 position-relative'
                style={{ backgroundColor: '#9e9e9e', position: 'relative' }} sx={{ boxShadow: 3, borderRadius: 2 }}
            >
                <Card className='w-100 position-relative p-3' style={{ backgroundColor: '#fff', height: skills && skills.length ? "100%" : "100%" }} sx={{ boxShadow: 3, borderRadius: 2 }}>
                    {loading ? (
                        <div className='h-100 mt-5 position-relative'>
                            <div className='w-100 position-relative'>
                                <Skeleton className='my-2' count={5} />
                            </div>
                        </div>
                    ) :
                        <div style={{
                            height: '100%'
                        }}>
                            <div className='d-flex justify-content-between'>
                                <Typography fontSize={18} fontWeight={500} className='px-2'>Your Skill Progress
                                </Typography>

                                <div className='cursor-pointer drag-handle' style={{ cursor: 'move' }}>
                                    <MdDragIndicator fontSize={24} />
                                </div>
                            </div>
                            {skills && skills.length === 0 ?
                                <div className='d-flex flex-column justify-content-center align-items-center'
                                    style={{
                                        height: "80%"
                                    }}>
                                    <SFNoData
                                        title="No Skills's Currently Practiced."
                                        description="This card will show the skills you are currently practicing"
                                    />
                                    <div className='mt-3'>
                                        <SFPublicSkillsLibrary />
                                    </div>
                                </div>
                                :
                                <div className='my-2'>
                                    <MaterialReactTable
                                        className=''
                                        columns={columns}
                                        data={skills}
                                        enableTopToolbar={false}
                                        enablePagination={false}
                                        enableStickyHeader={true}
                                        enableColumnActions={false}
                                        // initialState={{ columnVisibility: { practice: this.isListHasAnyPracticeAssignment() } }}
                                        muiTableBodyRowProps={({ row }) => ({
                                            onClick: (_) => {
                                                let index = parseInt(row.id);
                                                let assignment = skills[index];
                                                if (assignment.state === "Start" || assignment.state === "In Progress") {
                                                    if (this.props.selectedStudentUserName) {
                                                        return;
                                                    }
                                                    this.handleTakeQuizURL(assignment)
                                                }
                                            },
                                            sx: {
                                                cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                                            },
                                        })}

                                        muiTablePaperProps={
                                            {
                                                elevation: 0,
                                                sx: {
                                                    padding: 0,
                                                    margin: 0,
                                                    height: '100%',
                                                    position: 'relative'
                                                }
                                            }
                                        }
                                        muiTableHeadCellProps={{
                                            sx: {
                                                color: '#bb0000',
                                                fontWeight: '600',
                                                fontSize: "14px"
                                            }
                                        }}
                                        muiTableContainerProps={{
                                            sx: {
                                                height: '100%',
                                                position: 'relative'
                                            }
                                        }}

                                    />
                                </div>
                            }
                            {skills && skills.length === 0 ? null :
                                <div className='position-relative w-100 py-3 px-1' style={{
                                    height: '85%',
                                    overflow: 'auto',
                                }}>
                                    <div className='list-widget-status-container' style={{ gap: '1rem' }}>
                                        <div>
                                            <div style={{
                                                width: "26px",
                                                height: "26px",
                                                background: "#fff",
                                                border: '1px solid #ba0d2f',
                                                borderRadius: "50%",
                                            }} className='mr-1'>
                                                <RxCaretRight color='#ba0d2f' fontSize={22} />
                                            </div>
                                            In Progress
                                        </div>
                                        <div>
                                            <span className='status-circle bg-success fontClass-10 d-flex justify-content-center text-white align-items-center'>
                                                <FaCheck fontSize={16} color='white' />
                                            </span>
                                            Completed
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>}


                </Card>
            </Card>
        )
    }
}

export default SkillsWidget;
